<template>
    <div class="route__info-item">
        <div class="route__icon route__save route__statcount">
            <a
                title="Lagre på min side"
                class="hero__heart routelist__heart"
                :class="{ 'routelist__heart--selected': favourited }"
                @click.prevent="toggle"
            ></a>
        </div>
        <div class="route__info-title">{{ favourited ? 'Lagret' : 'Lagre tur' }}</div>
        <span v-if="justSaved" class="route__save-indicator">
            <img src="/icons/checkmark.svg" alt="">
            Oppdatert
        </span>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';

const props = defineProps({
    routeId: { type: Number, required: true },
    csrfToken: { type: String, required: true },
});

const favourited = ref(false);
// Momentary confirmation flash after a successful save - same pattern as
// the admin cache-clear indicators (Settings.vue), just without PrimeVue
// (not loaded on the public site) - a plain checkmark icon instead of
// PrimeIcons' pi-check.
const justSaved = ref(false);
let hideTimeout = null;

// Same endpoint/shape FavouriteList.vue already reads on /min-side - checks
// this one route's id against the viewer's full favourites list rather than
// the page being told the answer server-side.
onMounted(async () => {
    try {
        const response = await fetch('/xhr/frontend/users/favourites', {
            headers: { Accept: 'application/json' },
        });
        if (!response.ok) {
            return;
        }
        const data = await response.json();
        favourited.value = (data.favourites || []).some((route) => route.page_id === props.routeId);
    } catch (e) {
        // Leave the default (not favourited) state.
    }
});

async function toggle() {
    favourited.value = !favourited.value;
    justSaved.value = false;
    clearTimeout(hideTimeout);

    try {
        await fetch('/xhr/frontend/users/favourites/' + props.routeId, {
            method: 'POST',
            headers: { 'X-CSRF-TOKEN': props.csrfToken },
        });
        justSaved.value = true;
        hideTimeout = setTimeout(() => { justSaved.value = false; }, 2500);
    } catch (e) {
        // A failed request just means it'll show the previous state again
        // next time the page loads - same tolerance as FavouriteList.vue.
        // No success indicator in that case, since nothing was actually saved.
    }
}
</script>
